import { parseAwsGlo02DistributionList, resolveTagScalar } from './accountVpcName'

export const WORKLOAD_CLUSTER_REPO_PREFIX = 'atlas-workload-cluster'

/** GitLab workload cluster repo: atlas-workload-cluster-{application} */
export function buildWorkloadClusterRepoName(application: string): string {
	const app = String(application ?? '').trim().toLowerCase()
	if (!app) return ''
	return `${WORKLOAD_CLUSTER_REPO_PREFIX}-${app}`
}

/** EKS workload cluster name rendered by cluster onboarding (e.g. ntg-bbsdt-nonprod-wl-dv-kc-1). */
export function buildWorkloadClusterEksName(params: {
	portfolio: string
	application: string
	environment: string
	buildNo?: string
}): string {
	const portfolio = String(params.portfolio ?? '').trim().toLowerCase()
	const application = String(params.application ?? '').trim().toLowerCase()
	const environment = String(params.environment ?? '').trim().toLowerCase()
	const buildNo = String(params.buildNo ?? '1').trim() || '1'
	if (!portfolio || !application || !environment) return ''
	const serviceTier = environment === 'pd' ? 'prod' : 'nonprod'
	return `${portfolio}-${application}-${serviceTier}-wl-${environment}-kc-${buildNo}`
}

export function isWorkloadClusterRepoName(value: unknown): boolean {
	const name = String(value ?? '').trim().toLowerCase()
	return name.startsWith(`${WORKLOAD_CLUSTER_REPO_PREFIX}-`)
}

/** Resolve application from stored clusterName (supports legacy portfolio-application suffix). */
export function applicationFromWorkloadClusterRepoName(
	clusterName: string | undefined
): string {
	if (!clusterName?.trim()) return ''
	const prefix = `${WORKLOAD_CLUSTER_REPO_PREFIX}-`
	if (!clusterName.startsWith(prefix)) return ''
	const rest = clusterName.slice(prefix.length).trim()
	if (!rest) return ''
	// Legacy: atlas-workload-cluster-{portfolio}-{application}
	const legacy = rest.match(/^([a-z0-9]+)-([a-z]{1,5})$/)
	if (legacy) return legacy[2]
	return rest
}

/**
 * Portfolio prefix for SG/terraform naming.
 *
 * Cluster onboarding no longer collects `portfolio`, so the authoritative source is the
 * account distribution list — `aws-glo02-{group_name}-{platform_name}-{env}@globe.com.ph`,
 * whose `group_name` is the portfolio prefix. `portfolio` is still honoured first so legacy
 * cluster records keep resolving to the name their resources were actually created with;
 * `tagProject` remains the last-resort fallback.
 */
export function resolveClusterPortfolioPrefix(params: {
	portfolio?: string
	distributionList?: unknown
	tagProject?: unknown
}): string {
	const fromDetails = String(params.portfolio ?? '').trim().toLowerCase()
	if (fromDetails) return fromDetails

	const fromDistributionList = parseAwsGlo02DistributionList(
		resolveTagScalar(params.distributionList)
	)?.groupName
	if (fromDistributionList) return fromDistributionList

	return resolveTagScalar(params.tagProject).toLowerCase()
}
